<template>
  <el-dialog
      :title="'编辑'+typeStr"
      :visible.sync="scoreDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="600px"
      center>
    <el-form :model="serverForm" :rules="rules" ref="serverForm" label-width="120px">
      <el-form-item :label="'当前'+typeStr" >
        <el-input type="number" v-model.number="score" disabled></el-input>
      </el-form-item>
      <el-form-item label="修改数量" prop="score">
        <el-input type="number" v-model.number="serverForm.score" placeholder="请输入修改数量：增加(正数)、减少(负数)"></el-input>
      </el-form-item>
      <el-form-item label="变更原因" prop="content">
        <el-input type="textarea" v-model="serverForm.content" placeholder="请输入变更原因"></el-input>
      </el-form-item>

      <el-form-item class="flex align-center justify-around" label-width="0">
        <el-button class="padding-lr-xl" @click="resetForm('serverForm')">取消</el-button>
        <el-button class="padding-lr-xl" type="primary" @click="submitForm('serverForm')">提交</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { updateServiceIntegral} from "@/api/weilao";
export default {
  name: "editaAdminScoreDialog",
  props: {
    scoreDialog: {
      type: Boolean,
      default: false
    },
    score:{
      type: Number,
      default: 0
    },
    type:{
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      serverForm: {
        content: '',
        score: '',
      },
      rules: {
        score: [{required: true, message: '请输入修改数量', trigger: 'blur'}],
        content: [{required: true, message: '请输入变更原因', trigger: 'blur'}],

      }
    }
  },
  computed:{
    user() {
      return this.$store.state.user
    },
    typeStr(){
      return this.type === 1?'积分':this.type === 2?'金暖宝':'银暖宝'
    }
  },
  methods:{
    resetForm(formName){
      this.$refs[formName].resetFields();
      this.$emit('cancelDialog',false)
    },
    submitForm(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData(formName)
        }
      });
    },
    async submitData(formName) {
      let _state = await updateServiceIntegral(
          this.$route.params.id,
          this.serverForm.score,
          this.serverForm.content,
        this.type
      );
      this.$message.success(_state.info);
      this.$refs[formName].resetFields();
      this.$emit("cancelDialog", true);
    }
  },
  watch: {

  }
}
</script>

<style scoped lang="scss">

</style>
